<script>
  import Modal from './Modal'
  export default {
    Modal
  }
</script>



// WEBPACK FOOTER //
// index.vue?bcc58642